import { Fylke } from '@/domain/omrader';
import { transformGeometri } from './geometri';
import { Vegobjekt } from '@/domain/vegobjekter/Vegobjekt';
import type {
    Geometri as ApiGeometri,
    Vegobjekt as ApiVegobjekt,
} from '@/generated/nvdb/vegobjekter/models';

export type FylkeApiResponse = {
    navn: string;
    nummer: number;
    kartutsnitt: ApiGeometri;
    senterpunkt: ApiGeometri;
    vegobjekt: Pick<ApiVegobjekt, 'id'> & {
        type: number;
    };
};

export function transformFylker(fylkerResponse: FylkeApiResponse[]): Fylke[] {
    return fylkerResponse.map(fylke => transformFylke(fylke));
}

export function transformFylke(data: null | undefined): null;
export function transformFylke(data: FylkeApiResponse): Fylke;
export function transformFylke(data: FylkeApiResponse | null | undefined): Fylke | null {
    return data
        ? new Fylke(
              data.navn,
              data.nummer,
              transformGeometri(data.kartutsnitt),
              transformGeometri(data.senterpunkt),
              Vegobjekt.dummy(data.vegobjekt.id, data.vegobjekt.type)
          )
        : null;
}
